import {deleteCourse, deleteLesson, deleteTopic} from '@/api/course-builderapi'
import { mapActions } from 'vuex'
export const DeleteMixin = {

  data () {
    return {
      selected_deleteing_id:[],
      delete_id:[],
      activeConfirm:false,
      additionalPopUp:false,
      nonDeletableItems: []

      //deleting id for all module
    }
  },
  methods:{
    ...mapActions(
      ['SET_DELETED_COURSE_ID','SET_DELETED_Lesson_ID']
    ),
    openConfirm (id, singleObject, type, category) {
      console.log(id, singleObject, type, category)

      if (type === 'single') {
        this.selected_deleteing_id[0] = id
      }
      

      if (singleObject.status === true) {
      
        this.$vs.notify({
          title: 'Error',
          text: `Can't remove an active ${category}. Please deactivate the ${category} first.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      
      } else {
        this.delete_id.length = 0
        this.delete_id[0] = id
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this record ?',
          accept: this.acceptAlert
        })
      }
    },
    acceptAlert () {
      
      this.deletingLesson('single')

    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      //
      return selectedData
    },
    async deletingLesson (type) {
      const customer_id = this.$store.getters.customerId
      let payload = []
      try {
        if (type === 'bulk') {

          const deleting_ids = []

          if (this.listingtype === 'topic') {
            deleting_ids.push(...this.selected.map(ele => {
              return ele.id
            }))
          } else {
            const BulkSelected = this.getSelectedRows()
            for (let i = 0; i < BulkSelected.length; i++) {
              if (!BulkSelected[i].status) {
                deleting_ids.push(BulkSelected[i].id)
              }
              // }
            }
          }
          

          payload = {
            ids:deleting_ids
          }

        } else {
          payload = {
            ids:this.delete_id
          }
        }
        console.log(this.listingtype)
        if (this.listingtype === 'lesson') {
          const response = await deleteLesson(customer_id, payload)
          //this.fetchLessonList()
          this.SET_DELETED_Lesson_ID(payload.ids)
          this.deleteAlert(response, 'lesson')

          if (!this.additionalPopUp) {
            if (this.lessonLists.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }
          }

        } else if (this.listingtype === 'course') {
          console.log(payload.ids)
          const response = await deleteCourse(customer_id, payload)
          //this.fetchCourseList()
          this.SET_DELETED_COURSE_ID(payload.ids)
          this.deleteAlert(response, 'course')

          if (!this.additionalPopUp) {
            if (this.courseLists.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }
          }

        } else if (this.listingtype === 'topic') {
        
          const response = await deleteTopic(customer_id, payload)
          //this.fetchTopicList()
          this.deleteAlert(response, 'topic')

          if (!this.additionalPopUp) {
            if (this.topicLists.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }
          }
        }
        /* this.$vs.notify({
          title: 'Success',
          text: 'Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        }) */
        this.selected.length = 0

      } catch (error) {
        
      }
    },
    deleteAlert (response, type) {

      if (response.status === 200 || response.status === 202) {
        if (response.data.data.status) {
          this.additionalPopUp = true
          this.nonDeletableItems = response.data.data.nonDeletableEntity.map(item => { return item.name })
        } else {
          this.showSuccessMessage('Success', 'Deleted Successfully', 'success')
        }
      } else {
        this.showSuccessMessage('Error', 'Failed to delete', 'danger')
      }
    },
    // sinlgeDelete () {
    //   
    // },
    bulkDelete () {
      let count = 0

      if (this.listingtype === 'topic') {
        this.selected.filter(ele => {
          if(ele.status) {
            count = 1
          }
        })

      } else {
        const BulkSelected = this.getSelectedRows()
        for (let i = 0; i < BulkSelected.length; i++) {
          if (BulkSelected[i].status) {
            count = 1
          }
          // }
        }
      }
  
      if (count === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'All the selected records should be deactivated first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
  
      } else {
          
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure to delete all selected records?',
          accept: this.bulkAlertDelete
        })
  
      }
  
      
    },
    bulkAlertDelete () {
      
      this.deletingLesson('bulk')

    }
    // async bulkAlertDelete () {
    //   console.l
    //   const customer_id = this.$store.getters.customerId
    //   const ids = this.seleted.map(ele => {
    //     return ele.id
    //   })
    //   try {
    //     const payload = {
    //       ids
    //     }
    //     await deleteLesson(customer_id, payload)
    //     this.$vs.notify({
    //       title: 'Success',
    //       text: 'Deleted Successfully',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success',
    //       time: 3000
    //     })
    //     this.fetchLessonList()
    //     this.selected.length = 0

    //   } catch (error) {
    //     
    //   }

    // }
  }
}